import { render, staticRenderFns } from "./NavSubLink.vue?vue&type=template&id=64e6f2a9&"
import script from "./NavSubLink.vue?vue&type=script&lang=js&"
export * from "./NavSubLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports